export default "__VITE_ASSET__CKgZdHC3__"